module.exports = __webpack_public_path__ + "img/AddAssigneeIcon.47922804.svg";